import { ByComplexesAndAllowancesDataItem } from 'app/dataTypes/reports/data/common/ordersByClasses'

import { extractDateFromColumnKey } from './create-column-keys'
import { Entity } from './types'

export const createData = (
  data: Array<ByComplexesAndAllowancesDataItem>,
  columnKeysMain: Array<string>,
) => {
  const firstCountWithSubItems = data.reduce(
    (acc, { count }, index) => (acc || count - 1 !== index ? count : acc),
    0,
  )
  const noCountFromIndex = data.findIndex(({ count }) => count === firstCountWithSubItems)
  return data.map(({ id, title, complexTitle, count, valuesByDate, total }, index) => ({
    rowKey: id,
    rowData: columnKeysMain.reduce(
      (acc, key) => {
        const dateKey = extractDateFromColumnKey(key)

        acc[key] = {
          columnKey: key,
          value: String(valuesByDate[dateKey]) || '???',
        }
        return acc
      },
      {
        [Entity.Count]: {
          columnKey: Entity.Count as const,
          value: index > noCountFromIndex ? '' : String(count),
        },
        [Entity.Category]: {
          columnKey: Entity.Category as const,
          value: title,
          ...(complexTitle !== null ? { complexName: complexTitle } : {}),
          ...(index === noCountFromIndex ? { line2: 'Из\u00A0них:' } : {}),
        },
        [Entity.Total]: { columnKey: Entity.Total as const, value: String(total) },
      },
    ),
  }))
}
